export enum MeetingType {
  ANYMEET = 'ANYMEET',
  VONAGE = 'VONAGE',
}
